import { FC } from "react";

import { RadioButton, SpacingToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { withVar } from "themes/helpers";

interface IProps {
  onChange: (value: string) => void;
  checked: boolean;
  value: string;
}

const PERMISSIONS_MAP: Record<string, string> = {
  owner: "Admins only",
  normal: "Admins and agents",
  readOnly: "No user (API integration)",
};

export const CustomFieldPermissionField: FC<IProps> = ({ onChange, checked, value }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCheck = () => {
    onChange(value);
  };

  return (
    <Block marginTop={withVar(SpacingToken.Spacing2)}>
      <RadioButton onChange={handleCheck} checked={checked} data-testid={value}>
        {PERMISSIONS_MAP[value]}
      </RadioButton>
    </Block>
  );
};
